module.exports = require("babel-runtime/core-js/object/get-prototype-of");